import BaseModel from "../base_model.js";
import I18n from "../../base/i18n.js.jsx";

import InvestmentStatusEnum from "../../enums/investment_status.js";

class RawProjectParticipantModel extends BaseModel {

  rawListFilters() {
    return [
      {
        name: "investmentStatuses",
        displayName: this.fieldDisplayName("status"),
        type: "enum",
        enum: InvestmentStatusEnum,
        allowClear: true,
        clearItem: I18n.t("enum.investment_status.all"),
        multiple: true
      }
    ]
  }

}
const ProjectParticipantModel = new RawProjectParticipantModel();

export { RawProjectParticipantModel, ProjectParticipantModel }

